import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_346: DocMigration = {
  maxSchemaVersion: "0.0.346",
  description: "Set new overrideable property to default true",

  apply(json: any) {
    for (const id in json.optionRules) {
      const rule = json.optionRules[id];
      rule.overridable = true;
    }
    return json;
  },
};

export default migration_0_0_346;
